import type { InternalRequest } from '../client.js';

export interface Geofence {
  id: number;
  name: string;
  description?: string | null;
  area: string; // Traccar WKT-ish: CIRCLE (lat lng, r) | POLYGON ((...)) | LINESTRING (...)
  attributes?: Record<string, unknown> | null;
}

export function geofencesEndpoints(req: InternalRequest) {
  return {
    /** GET /geofences — Traccar-proxy list (staff-readable per proxy.routes.ts:140). */
    list: () => req.request<Geofence[]>('/geofences'),
  };
}
